//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import responsiveMixin from '../../../utils/mixins/responsive';
import scrollMixin from '../../../utils/mixins/scroll';
import Button, { BUTTON_TYPES, BUTTON_SIZES } from '../Button';
import Typography, { TYPOGRAPHY_VARIANTS, TYPOGRAPHY_TYPES } from '../Typography';
export default {
  name: 'Hero',
  components: {
    Button: Button,
    Typography: Typography
  },
  mixins: [responsiveMixin, scrollMixin],
  data: function data() {
    return {
      BUTTON_TYPES: BUTTON_TYPES,
      BUTTON_SIZES: BUTTON_SIZES,
      TYPOGRAPHY_VARIANTS: TYPOGRAPHY_VARIANTS,
      TYPOGRAPHY_TYPES: TYPOGRAPHY_TYPES
    };
  },
  props: {
    cta: {
      type: [Object, Array]
    },
    title: {
      type: String,
      required: true
    },
    superTitle: {
      type: String,
      default: ''
    },
    backgroundUrlDesktop: {
      type: String,
      default: ''
    },
    backgroundUrlMobile: {
      type: String,
      default: ''
    },
    videoUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    ctas: function ctas() {
      var ctas = Array.isArray(this.cta) ? this.cta : [this.cta];
      return ctas.filter(function (cta) {
        return cta.content;
      });
    },
    backgroundUrl: function backgroundUrl() {
      return this.$responsive_isTabletLarge ? this.backgroundUrlDesktop : this.backgroundUrlMobile || this.backgroundUrlDesktop;
    }
  },
  methods: {
    handleCtaClick: function handleCtaClick(cta) {
      if (cta.onClick) {
        cta.onClick();
      }
    }
  }
};